export const calculateSavingsInterestWithMonthlyBalances = (
    rate: number,
    initialBalance: number,
    monthlyContribution: number,
    months: number,
) => {
    const monthlyRate = rate / 12 / 100 // convert annual rate to monthly and percentage to decimal
    const totalContributed = initialBalance + monthlyContribution * months
    let totalBalance = initialBalance
    let totalInterest = 0
    const monthlyBalances = [initialBalance] // first month is the initial balance

    for (let i = 0; i < months; i++) {
        const interest = totalBalance * monthlyRate
        totalBalance += interest + monthlyContribution
        totalInterest += interest
        monthlyBalances.push(totalBalance)
    }

    return {
        totalContributed: totalContributed,
        totalInterest: totalInterest,
        totalBalance: totalBalance,
        monthlyBalances: monthlyBalances,
    }
}
